import { IResponse } from '../../domains/types';

interface ITenantAnnotations {
  TenantClaims?: {
    cdp_client_key?: string;
  };
  [key: string]: any;
}
type ITenantLabels = {
  ProductCode: EProductCodes;
  clientKey?: string;
  TrialExpirationDate?: string;
  CustomerEnvironmentType?: string;
  [key: string]: string | number | boolean;
};

export interface ITenant {
  id: string;
  name: string;
  displayName: string;
  organizationId: string;
  serviceId?: string;
  labels: ITenantLabels;
  annotations: ITenantAnnotations;
  systemId?: string;
  state?: string;
}

export interface IGetTenantsRequestPayload {
  pageNumber: number;
  pageSize?: number;
  organizationId?: string;
  serviceId?: string;
}
export interface IGetTenantsResponse extends IResponse<ITenant> {}

export enum EProductCodes {
  XMCloud = 'XMCloud',
  HeadlessCMS = 'HeadlessCMS',
  Connect = 'Connect',
  OrderCloud = 'OrderCloud',
  CDP = 'CDP',
  Personalize = 'Personalize',
  Search = 'Search',
  Discover = 'Discover',
  Send = 'Send',
  DAM = 'DAM',
  ContentOperations = 'ContentOperations',
}

export interface IGetTenantsResponse {
  totalCount: number;
  pageSize: number;
  pageNumber: number;
  data: ITenant[];
}

export interface IInventoryListResponse<T> {
  totalCount: number;
  pageSize: number;
  pageNumber: number;
  data: T;
}
